import React, { Component } from "react";
import "./index.scss";
import qs from "qs";
class Userprofilenav extends Component {
  state = {
    basicdetailbtn: false,
    advancedetailbtn: false,
    rateCardDetailbtn: true,
    plansandBilling: false,
  };
  componentDidMount() {
    let plan = window.location.search.includes("plan");
    const params = qs.parse(this.props.location.search.replace(/\?/g, ""));
    if(params.tab){
  
      this.setState(
        {
          ...this.state.userprofile,
          [params.tab]: true,
        },
        () =>
          this.props.toggleuserprofile({
            ...this.state.userprofile,
            [params.tab]: true,
          })
      );
    }
    if (plan ) {
      this.setState(
        {
          basicdetailbtn: false,
          advancedetailbtn: false,
          rateCardDetailbtn: false,
          plansandBilling: true,
        },
        () =>
          this.props.toggleuserprofile({
            basicdetailbtn: false,
            advancedetailbtn: false,
            rateCardDetailbtn: false,
            plansandBilling: true,
          })
      );
    }
  }
  render() {
    return (
      <div className="profilenav fullorder_data">
        <div className=" userprofilennav ">
          <div className="ordfill">
            <div className="profilefillwrap">
              <div className="left" style={{ marginLeft: "7px" }}>
                <div
                  style={{
                    color: "#000",
                    fontSize: "12px",
                    letterSpacing: "0.032em",
                    lineHeight: "24px",
                  }}
                >
                  Your Profile
                </div>
              </div>
            </div>
            <div className="secondwrap">
              <div className="filtertab">
                <div
                  className={
                    this.props.loading
                      ? "non-cursor-pointer tab hover-order-underline-animation "
                      : this.state.basicdetailbtn
                      ? "tab  hover-order-underline-animation-click"
                      : "tab hover-order-underline-animation"
                  }
                >
                  <button
                    className={this.state.basicdetailbtn ? "active" : ""}
                    value=""
                    onClick={() => {

                      window.location.assign(
                        `${process.env.REACT_APP_NEW_APP}/profile`
                      )
                     
                    }}
                  >
                    Basic Details
                  </button>
                </div>

               
                <div
                  className={
                    this.props.loading
                      ? "non-cursor-pointer tab hover-order-underline-animation "
                      : this.state.rateCardDetailbtn
                      ? "tab  hover-order-underline-animation-click"
                      : "tab hover-order-underline-animation"
                  }
                >
                  <button
                    className={this.state.rateCardDetailbtn ? "active" : ""}
                    value="delivered"
                    onClick={() => {
                      this.setState(
                        {
                          basicdetailbtn: false,
                          advancedetailbtn: false,
                          rateCardDetailbtn: true,
                          plansandBilling: false,
                        },
                        () =>
                          this.props.toggleuserprofile({
                            basicdetailbtn: false,
                            advancedetailbtn: false,
                            rateCardDetailbtn: true,
                            plansandBilling: false,
                          })
                      );
                    }}
                  >
                    Rate Cards
                  </button>
                </div>
                <div
                  className={
                    this.props.loading
                      ? "non-cursor-pointer tab hover-order-underline-animation "
                      : this.state.plansandBilling
                      ? "tab  hover-order-underline-animation-click"
                      : "tab hover-order-underline-animation"
                  }
                >
                  <button
                    className={this.state.plansandBilling ? "active" : ""}
                    value="delivered"
                    onClick={() => {
                      this.setState(
                        {
                          basicdetailbtn: false,
                          advancedetailbtn: false,
                          rateCardDetailbtn: false,
                          plansandBilling: true,
                        },
                        () =>
                          this.props.toggleuserprofile({
                            basicdetailbtn: false,
                            advancedetailbtn: false,
                            rateCardDetailbtn: false,
                            plansandBilling: true,
                          })
                      );
                    }}
                  >
                    Plans & Billing
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Userprofilenav;
